/**
 * Функция, возвращающая id самого "старого" тоста, который нужно скрыть.
 * "Старость" тоста зависит от того, где находится контейнер тостов.
 * @param toastsStack - список всех тостов (видимых и скрытых)
 * @param appearsFromBottomToTop - флаг того, как тост появляется на странице (сверху вниз, снизу вверх)
 * @returns рассчитанное значение таймаута
 */
export function findOldestToastIdToHide(toastsStack, appearsFromBottomToTop) {
  var _toastsStack$find, _toastsStack$slice$re;
  var oldestVisibleToastId = appearsFromBottomToTop ? (_toastsStack$find = toastsStack.find(function (toast) {
    return !toast.hidden;
  })) === null || _toastsStack$find === void 0 ? void 0 : _toastsStack$find.id : (_toastsStack$slice$re = toastsStack.slice().reverse().find(function (toast) {
    return !toast.hidden;
  })) === null || _toastsStack$slice$re === void 0 ? void 0 : _toastsStack$slice$re.id;
  return oldestVisibleToastId;
}